var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "award award-row", class: _vm.award.class }, [
    _c(
      "div",
      { staticClass: "award-icon award-item-element" },
      [
        _vm.item.filepath
          ? [
              _c("img", {
                staticClass: "award-display",
                attrs: { src: _vm.item.filepath },
              }),
            ]
          : [
              _vm.award.icon === "medal"
                ? [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 50 77.386",
                        },
                      },
                      [
                        _c("path", {
                          staticClass: "cls-1",
                          attrs: {
                            d: "M40.141,32.494h0c-.377-.288-.763-.565-1.154-.831a.618.618,0,0,1-.09-.061A24.649,24.649,0,0,0,30.518,28,25.211,25.211,0,0,0,19.48,28a24.673,24.673,0,0,0-8.448,3.654l0,0c-.4.266-.785.547-1.169.838a25,25,0,1,0,30.282,0ZM25,74.755a22.371,22.371,0,1,1,9.423-42.662.267.267,0,0,1,.046.02l.015.007.012.005.078.041h0l.213.108c.14.066.279.132.416.2.095.049.188.1.281.149.124.066.247.129.369.2.105.056.207.117.31.178s.223.125.33.191.22.134.33.2.2.122.3.188.225.149.335.225c.095.061.19.125.283.188.11.076.218.156.325.234s.189.132.281.2.184.142.277.213.212.161.315.244c.022.017.041.034.061.049.174.139.342.278.511.423l0,0A22.371,22.371,0,0,1,25,74.755Z",
                          },
                        }),
                        _c("path", {
                          staticClass: "cls-1",
                          attrs: {
                            d: "M31.11,25.381a27.2,27.2,0,0,1,7.877,3.107L49.42,0H31.779L26.431,14.609l3.882,10.6C30.579,25.264,30.846,25.32,31.11,25.381Z",
                          },
                        }),
                        _c("path", {
                          staticClass: "cls-1",
                          attrs: {
                            d: "M18.888,25.376A28.218,28.218,0,0,1,27.3,24.8L18.216,0H.573L11.011,28.488A27.41,27.41,0,0,1,18.888,25.376Z",
                          },
                        }),
                        _c("path", {
                          staticClass: "cls-1",
                          attrs: {
                            d: "M37.768,37.405a19.546,19.546,0,0,0-4.424-2.846c-.032-.014-.064-.031-.1-.048a19.69,19.69,0,1,0,4.52,2.894Zm-8.1,18.363.953,5.569-5-2.631a1.351,1.351,0,0,0-1.252,0l-5,2.631.956-5.569a1.355,1.355,0,0,0-.386-1.19l-4.048-3.945,5.6-.812a1.348,1.348,0,0,0,1.012-.735l2.5-5.07,2.5,5.07a1.346,1.346,0,0,0,1.012.735l5.592.812-4.047,3.945A1.343,1.343,0,0,0,29.67,55.768Z",
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.award.icon === "trophy"
                ? [
                    _c(
                      "svg",
                      {
                        staticStyle: { "enable-background": "new 0 0 100 100" },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          version: "1.1",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 100 100",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M59.2,61.3l2.5-1.2c7-3.4,11.2-11.4,11.2-18.1V11.8c0-1.5-1.4-2.7-3-2.7H30.1c-1.7,0-3,1.2-3,2.7V42  c0,6.7,4.3,14.7,11.2,18.1l2.5,1.2c2,1,3.3,2.9,3.3,4.9v9.7h-5.2c-1,0-1.8,0.8-1.8,1.8v5.4h-5.3c-1.7,0-3,1.4-3,3V90  c0,0.5,0.4,0.8,0.8,0.8h40.6c0.5,0,0.8-0.4,0.8-0.8v-3.9c0-1.7-1.4-3-3-3h-5.3v-5.4c0-1-0.8-1.8-1.8-1.8h-5.2v-9.7  C55.9,64.2,57.2,62.3,59.2,61.3z M55.5,45.1L50,42.2l-5.5,2.9C44,45.4,43.4,45.3,43,45c-0.5-0.3-0.7-0.9-0.6-1.4l1-6.1L39,33.2  c-0.4-0.4-0.5-1-0.4-1.5c0.2-0.5,0.6-0.9,1.2-1l6.1-0.9l2.7-5.5c0.2-0.5,0.7-0.8,1.3-0.8s1.1,0.3,1.3,0.8l2.7,5.5l6.1,0.9  c0.6,0.1,1,0.5,1.2,1c0.2,0.5,0,1.1-0.4,1.5l-4.4,4.3l1,6.1c0.1,0.6-0.1,1.1-0.6,1.4c-0.3,0.2-0.6,0.3-0.9,0.3  C55.9,45.3,55.7,45.2,55.5,45.1z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M23.9,16.3H13.4c-0.7,0-1.4,0.6-1.3,1.4c0.2,4.8,1.8,20.5,11.4,27.5c0.4,0.3,1,0,1-0.5v-5.5c0-0.2-0.1-0.3-0.2-0.4  c-1.9-2-3.5-4.7-4.7-8.2c-0.9-2.7-1.6-5.4-1.9-7.7c-0.1-0.5,0.3-1,0.8-1h5.4c0.3,0,0.6-0.3,0.6-0.6V17  C24.5,16.6,24.2,16.3,23.9,16.3z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M75.7,38.8c-0.1,0.1-0.2,0.3-0.2,0.4v5.5c0,0.5,0.6,0.8,1,0.5c9.6-7,11.2-22.8,11.4-27.5c0-0.8-0.6-1.4-1.3-1.4H76.1  c-0.3,0-0.6,0.3-0.6,0.6v4.4c0,0.3,0.3,0.6,0.6,0.6h5.4c0.5,0,0.9,0.5,0.8,1c-0.4,2.3-1,5-1.9,7.7C79.1,34.1,77.6,36.8,75.7,38.8z",
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "award-content award-item-element" }, [
      _c("div", { staticClass: "award-item-sub-element" }, [
        _c("div", { staticClass: "award-level" }, [
          _vm._v(_vm._s(_vm.award.value)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "award-item-sub-element" }, [
        _c("h4", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.item.title) + " - " + _vm._s(_vm.item.year)),
        ]),
      ]),
      _vm._v(" "),
      _vm.item.sub_title
        ? _c("div", { staticClass: "award-item-sub-element" }, [
            _c("div", { staticClass: "sub-title" }, [
              _vm._v(_vm._s(_vm.item.subtitle)),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }